import React from 'react';
import logo from '/imageAssets/pfizer-logo-color.png';

const MobileWarning = () => {
  return (
    <div className="mobile-warning">
      <img src={logo} alt="Pfizer Logo" className="logo" />
      <h1 style={{color: 'black'}}>Please view on desktop</h1>
      <p style={{color: 'black'}}>For the best experience, please access this application on a desktop device with a screen width of at least 1024px width.</p>
    </div>
  );
};

export default MobileWarning;